import { createTheme } from "@mui/material/styles";
import { COLORS } from "./constants";

// Crear tema personalizado para Material UI
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: COLORS.primary,
    },
    secondary: {
      main: COLORS.text,
    },
    background: {
      default: COLORS.bgDark,
      paper: COLORS.bgLight,
    },
    text: {
      primary: COLORS.text,
      secondary: COLORS.text,
    },
    error: {
      main: COLORS.error,
    },
    success: {
      main: COLORS.success,
    },
    warning: {
      main: COLORS.warning,
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    button: {
      textTransform: "none",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          padding: "10px 20px",
        },
        contained: {
          boxShadow: "none",
          "&:hover": {
            boxShadow: "none",
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          backgroundColor: COLORS.bgLight,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.bgLight,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: COLORS.bgLight,
          boxShadow: "0 2px 10px rgba(0, 0, 0, 0.1)",
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        indicator: {
          height: 3,
          borderRadius: "3px 3px 0 0",
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 500,
          fontSize: "1rem",
        },
      },
    },
  },
});

export default theme;
